export default __webpack_public_path__ + "static/media/gallery_02.59c4ab85.jpg";